import React, { useState, useEffect } from 'react';
import '../App.css';
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom';
import { GET_PARTS_LIST_FROM_WH, loadOEbyCarCodeType, setIsSelectingVehicle, setSelectedBrand, setSelectedYear, setSelectedModel, setSelectedVersion, eraseSelectedVehicle } from '../reducers/vehicle';
import ProductTile from '../Common/Tiles/ProductTile';
import { Close, FilterAltOutlined, FilterList, PriceChangeOutlined, Sort } from '@mui/icons-material';
import Button from '../Common/Button';
import Product from '../Common/Classes/Product';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowBackSharp } from '@mui/icons-material';
import { AddCar } from '../Utilities/Icons';
import { getConfigData, getContentData } from '../Whitelabel/websitesData_sd_test';
import { currentSite } from '../App';
import UHD_banner_pecas_01 from '../images/UmuaramaMotos/umotos_pecas_01.webp';
import UHD_banner_boutique_01 from '../images/UmuaramaMotos/boutique_general.jpg';
import UHD_banner_acessorios_01 from '../images/UmuaramaMotos/UDH_banner_harley_01.1.webp';
import KTM_banner_01 from '../images/UmuaramaMotos/U_ktm_bg_04.1.webp';
import Triumph_banner_01 from '../images/UmuaramaMotos/U_triumph_bg_03.1.webp';
import { firestore } from '../firebase';
import { getFirestore, collection, query, where, getDocs,onSnapshot } from 'firebase/firestore';
import { Home, KeyboardArrowUp } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

import harleyLogo from '../images/UmuaramaMotos/harley_logo_small_white.png';
import ktmLogo from '../images/UmuaramaMotos/ktm_logo_white.png';
import triumphLogo from '../images/UmuaramaMotos/triumph_logo_white.png';

import { getFunctions, httpsCallable } from "firebase/functions";
import { BrandsList } from '../Utilities/BrandsList';
import { Search } from '@mui/icons-material';
import { Helmet } from 'react-helmet-async';
import websitesIndexData from '../websitesIndexData';
import { buildHelmetData } from '../Utilities/HelmetTool';
import { SliderProducts } from '../Utilities/SliderProducts';
import { clothingItems } from '../Utilities/clothingItems';
import { fathersDayItems } from '../Utilities/fathersDayItems';
import { categoriesCars, categoriesBikes, subcatPeloNomeCategoria, subcatPeloNomeCategoriaBikes, idsSubcategoriaPeloNome, categoryAxle, bikeBrands } from '../Utilities/CategoriesLists';
import { impulseItems } from '../Utilities/impulseItems';
import { enginesItems } from '../Utilities/enginesItems';

function Products() {
    const { category } = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    // Get site-specific data using the new structure
    const configData = getConfigData(currentSite);
    const contentData = getContentData(currentSite);

    const { products, image } = location.state || {};
    const [allProducts, setAllProducts] = useState([]);
    const [sortedProducts, setSortedProducts] = useState([]);
    const [displayedProducts, setDisplayedProducts] = useState([]); // For filtered products
    const [sortOption, setSortOption] = useState('default');
    const vehicleState = useSelector(state => state.vehicle);
    const selectedCar = useSelector(state => state.vehicle.selectedVehicle);
    const internalID = (configData.noVehicle) ? '68444' : selectedCar?.InternalID;
    const allOEs = useSelector(state => state.vehicle.carOEs);
    const { selectedBrand, isSelectingVehicle, selectedYear, selectedModel, selectedVersion } = useSelector(state => state.vehicle);
    const [priceRangeStart, setPriceRangeStart] = useState('');
    const [priceRangeEnd, setPriceRangeEnd] = useState('');
    const [filteredSizes, setFilteredSizes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const [searchText, setSearchText] = useState(''); // Add search text state

    const [ expandedFilters, setExpandedFilters ] = useState(false);

    const [hasClothing, setHasClothing] = useState(false); //!!!dynamically update this if category has clothing!!!

    const [categoryName, setCategoryName] = useState('');

    const [brandName, setBrandName] = useState('');

    const [productsDirect, setProductsDirect] = useState([]);

    // Add a new state to track if productsDirect is being loaded
    const [isLoadingDirect, setIsLoadingDirect] = useState(false);

    // First, add a new state for vestuario loading
    const [isLoadingVestuario, setIsLoadingVestuario] = useState(false);

    const capitalizeWords = (str) => {
        if (str) {
            return str.split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        }
    };

    // useEffect(() => {
    //     console.log('allOEs.length: ', allOEs.length);
    //     console.log('productsDirect.length: ', productsDirect.length);
    // }, [allOEs, productsDirect]);

    const getCategoryImage = () => {
        const Categories = (selectedBrand && bikeBrands.includes(selectedBrand.toLowerCase())) ? categoriesBikes : categoriesCars;
        return Categories[category] || null;
    };

    useEffect(() => {
        if((internalID !== undefined) && (internalID !== "")) {
            dispatch(loadOEbyCarCodeType(internalID)).then(() => {
                if (displayedProducts.length > 0) {
                    setIsLoading(false); // Set to false after initial data is loaded
                }
            });
        } else {
            setIsLoading(false); // Set to false if there's no internalID
        }
    }, [selectedCar]);

    useEffect(() => {
        if (category && configData.defaultStore === 'UmuaramaMotos') {
            let formatted = category
                .replace(/-/g, ' ')  // Replace all hyphens with spaces
                .split(' ')          // Split into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())  // Capitalize first letter of each word
                .join(' ');          // Join back with spaces
            
            // Replace 'Acessorio' with 'Acessório'
            formatted = formatted.replace('Acessorio', 'Acessório');
            // console.log('formatted:', formatted);
            setCategoryName(formatted);
        } else {
            if (category === 'vestuario') {
                setCategoryName('Vestuário');
            } else if (category === 'Acessorios-Destaque') {
                setCategoryName('Acessórios em destaque');
            } else if (category === 'dia-dos-pais') {
                setCategoryName('Dia dos Pais');
            } else if (category === 'motores') {
                setCategoryName('Tudo em Motores');
            } else {
                setCategoryName(category);
            }
        }
    }, [category]);

    useEffect(() => {
        if (category && configData.defaultStore === 'UmuaramaMotos') {
            // Split only at the first hyphen
            const parts = category.split(/-(.+)/);
            setBrandName(parts[1]); // parts[1] will contain everything after the first hyphen
        }
    }, [category]);

    const topMargin = (configData.defaultStore === 'UmuaramaHD' || configData.defaultStore === 'UmuaramaMotos') ? '440px' : '20px';
    const categoryImages = {
        'Boutique-harley-davidson': UHD_banner_boutique_01,
        'Acessorios-harley-davidson': UHD_banner_acessorios_01,
        'Peças-harley-davidson': UHD_banner_pecas_01,

        'Boutique-ktm': KTM_banner_01,
        'Acessorios-ktm': KTM_banner_01,
        'Peças-ktm': UHD_banner_pecas_01,

        'Boutique-triumph': Triumph_banner_01,
        'Acessorios-triumph': Triumph_banner_01,
        'Peças-triumph': UHD_banner_pecas_01,
        
    };
    
    const brandLogos = {
        'Boutique-harley-davidson': harleyLogo,
        'Acessorios-harley-davidson': harleyLogo,
        'Peças-harley-davidson': harleyLogo,
    
        'Boutique-ktm': ktmLogo,
        'Acessorios-ktm': ktmLogo,
        'Peças-ktm': ktmLogo,
    
        'Boutique-triumph': triumphLogo,
        'Acessorios-triumph': triumphLogo,
        'Peças-triumph': triumphLogo,
    }

    // Use the category to get the corresponding image
    const productPageBg = (configData.defaultStore === 'UmuaramaHD' || configData.defaultStore === 'UmuaramaMotos') ? categoryImages[category] || '' : '';

    // Helper to format prices in Brazilian format
    const formatCurrency = (value) => {
        const formatter = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        return formatter.format(value);
    };

    // Helper to parse formatted prices back to number
    const parseCurrency = (formattedValue) => {
        return parseFloat(formattedValue.replace(/\./g, '').replace(',', '.').replace('R$', '').trim()) || 0;
    };

    const HDcategories = {
        "Boutique": "Boutique",
        "Acessórios": "Acessorios",
        "Peças": "Peças",
        "KTM": "KTM",
        "Triumph": "Triumph",
    };

    const [selectedSize, setSelectedSize] = useState('default');

    useEffect(() => {
        if ((category === 'dia-das-maes' || category === 'vestuario') && configData.noVehicle) {
            dispatch(setIsSelectingVehicle(false));
        }
    }, [category])

    // useEffect(() => {
    //     if (!selectedVersion && (category !== 'dia-das-maes' || category !== 'vestuario') && !configData.noVehicle) {
    //         dispatch(setIsSelectingVehicle(true));
    //     }
    // }, [selectedVersion])

    const vehicleSelectWithBrand = (brand) => {
        dispatch(setSelectedVersion(''));
        dispatch(setSelectedModel(''));
        dispatch(setSelectedYear(''));
        dispatch(setSelectedBrand(brand));
        dispatch(setIsSelectingVehicle(true));
    }

    const openVehicleSelectOnly = () => {
        dispatch(setIsSelectingVehicle(true));
    }

    const getCategoriesIds = (name) => {
        // Get the appropriate subcategories mapping based on brand
        const subCategories = bikeBrands.includes((selectedBrand || '').toLowerCase()) 
            ? subcatPeloNomeCategoriaBikes[name] 
            : subcatPeloNomeCategoria[name];

        // If no subcategories found for the name, return empty array
        if (!subCategories) {
            return [];
        }

        const listofIds = [];
        subCategories.forEach((element) => {
            const ids = idsSubcategoriaPeloNome[element];
            if (ids) {
                listofIds.push(...ids);
            }
        });
        return listofIds;
    };

    const loadParts = async (car, ids, starting, subcategory, allOEs) => {
        // Add early return if required data is missing
        if (!car || !car.InternalID || !ids || !allOEs) {
            console.log('Missing required data for loadParts:', { car, ids, allOEs });
            return;
        }

        setIsLoadingDirect(true); // Set loading state when starting to load productsDirect

        try {
            const partsList = [];

            ids.forEach((categoryId) => {
                if (allOEs.parts && Array.isArray(allOEs.parts)) {
                    allOEs.parts.forEach((oe) => {
                        if (oe && oe.id_prod && oe.oe_gpm) {
                            if (oe.id_prod.toString() === categoryId.toString()) {
                                if (!partsList.includes(oe.oe_gpm)) partsList.push([oe.oe_gpm]);
                            }
                        }
                    });
                }
            });

            const distinctIds = partsList;
            const axle = categoryAxle[subcategory?.toString() || 'default'];

            const requestPayload = {
                data: distinctIds,
                cross: false,
            };

            if (configData.defaultStore === 'UmuaramaHD') {
                requestPayload.brand = 'GENUINAHARLEYDAVIDSON';
            } else if (configData.defaultStore === 'UmuaramaMotos') {
                const harleyPayload = {
                    ...requestPayload,
                    brand: 'GENUINAHARLEYDAVIDSON',
                };
                const ktmPayload = {
                    ...requestPayload,
                    brand: 'GENUINAKTM',
                };

                const [WHpartsHarley, WHpartsKTM] = await Promise.all([
                    getPartsListFromWH(harleyPayload),
                    getPartsListFromWH(ktmPayload),
                ]);

                const combinedParts = [...(WHpartsHarley || []), ...(WHpartsKTM || [])];
                setProductsDirect(combinedParts);
                // setIsLoadingDirect(false); // Set loading to false after products are loaded
                return;
            } else if (configData.defaultStore === 'NissulYamaha' || configData.defaultStore === 'BelcarYamaha') {
                requestPayload.brand = 'GENUINAYAMAHA';
            } else {
                requestPayload.axle = axle;
                requestPayload.carID = car.InternalID.toString();
            }

            const WHparts = await getPartsListFromWH(requestPayload);
            if (WHparts) {
                setProductsDirect(WHparts);
            }
            // setIsLoadingDirect(false); // Set loading to false after products are loaded
        } catch (error) {
            console.error('Error loading parts:', error);
            setIsLoadingDirect(false); // Make sure to set loading to false even if there's an error
        }
    };

    const getPartsListFromWH = async (info) => {
        const functions = getFunctions();
        const callableGetPartsListFromWH = httpsCallable(functions, `${(configData.noVehicle) ? 'getPartsListFromBrand' : 'getPartsListFromWH'}`);

        const parts = await callableGetPartsListFromWH(info).then((result) => {
            let i = 0;
            const listofArticles = [];
            result.data.forEach((document) => {
                i = i + 1;
                if (document != null) {
                    const listOfSellers = document["sellersList"];
                    const growableList = [];
                    const storeprice = configData.defaultStore === "GoParts" ? "price_ecommerce_gp" : "price_ecommerce_seller";

                    listOfSellers.forEach((element) => {
                        if (configData.storeSellersWarehouses.includes(element)) {
                            growableList.push({
                                id: document["id"].toString(),
                                active: document[element]["active"],
                                name: document[element]["name"],
                                price: document[element]["price"],
                                stock: document[element]["stock"],
                                price_ecommerce: document[element].hasOwnProperty(storeprice)
                                    ? document[element][storeprice]
                                    : document[element]["price"],
                                distance: 1
                            });
                        }
                    });

                growableList.sort((a, b) => {
                    var mina = a.price_ecommerce < a.price ? a.price_ecommerce : a.price;
                    var minb = b.price_ecommerce < b.price ? b.price_ecommerce : b.price;

                    if (mina < minb) return -1;
                    if (minb < mina) return 1;
                    return 0;
                });

                    listofArticles.push({
                        id: document['id'],
                        active: document['active'],
                        description: document['desc'],
                        ds_number: document['ds_number'],
                        ds_number_gp: document['ds_number_gp'],
                        id_prod: document['id_prod'],
                        id_supplier: document['id_supplier'],
                        images: document['imhash'],
                        listofPropertiesbyCar: document.hasOwnProperty('prop_car')
                            ? document['prop_car']
                            : null,
                        priority: document['priority'],
                        ds_numbers: document['ds_numbers'],
                        weight: document.hasOwnProperty('pesoG')
                            ? document['pesoR']
                            : -1,
                        weightCubic: document.hasOwnProperty('pesoG')
                            ? document['pesoG']
                            : -1,
                        height: document.hasOwnProperty('altCM')
                            ? document['altCM']
                            : -1,
                        depth: document.hasOwnProperty('profCM')
                            ? document['profCM']
                            : -1,
                        width: document.hasOwnProperty('largCM')
                            ? document['largCM']
                            : -1,
                        sellers: growableList,
                    });
                }
            });

            if (listofArticles.length === 0) {
                listofArticles.push({
                    id: "0",
                    active: false,
                    description: "Sem cadastro de peça",
                    ds_number: "Sem cadastro de peça",
                    ds_number_gp: "Sem cadastro de peça",
                    id_prod: "Sem cadastro de peça",
                    id_supplier: "0",
                    images: [],
                    sellers: [],
                    listofPropertiesbyCar: {},
                    priority: 0,
                    weight: -1,
                    height: -1,
                    depth: -1,
                    width: -1,
                    ds_numbers: [],
                });
            }

            listofArticles.sort((a, b) => {
                const totalA = a.sellers.reduce((tot, item) => tot + Number(item.stock), 0);
                const totalB = b.sellers.reduce((tot, item) => tot + Number(item.stock), 0);
                return totalB - totalA;
            });

            return listofArticles;
        }).catch((error) => {
            console.error(error);
        });

        return parts;
    };

    // Optimized function to fetch products from Firestore
    const fetchProductsFromFirestore = async (productIds, cacheKey = null) => {
        // Check cache first
        if (cacheKey) {
            const cached = sessionStorage.getItem(cacheKey);
            if (cached) {
                return JSON.parse(cached);
            }
        }

        const batchSize = 10;
        const batches = [];
        for (let i = 0; i < productIds.length; i += batchSize) {
            batches.push(productIds.slice(i, i + batchSize));
        }

        const allProducts = [];
        const warehouseRef = collection(firestore, 'gp_warehouse');
        const storeprice = configData.defaultStore === "GoParts" ? "price_ecommerce_gp" : "price_ecommerce_seller";
        
        // Process batches in parallel for better performance
        const batchPromises = batches.map(async (batch) => {
            const q = query(warehouseRef, where('ds_number_gp', 'in', batch));
            const querySnapshot = await getDocs(q);
            
            const batchProducts = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                if (document != null && document.sellersList) {
                    const growableList = [];
                    
                    // Filter sellers more efficiently
                    const validSellers = document.sellersList.filter(element => 
                        configData.storeSellersWarehouses.includes(element)
                    );

                    validSellers.forEach((element) => {
                        if (document[element]) {
                            growableList.push({
                                id: document.id?.toString() || '',
                                active: document[element].active || false,
                                name: document[element].name || '',
                                price: document[element].price || 0,
                                stock: document[element].stock || 0,
                                price_ecommerce: document[element][storeprice] || document[element].price || 0,
                                distance: 1
                            });
                        }
                    });

                    // Only add product if it has valid sellers
                    if (growableList.length > 0) {
                        batchProducts.push({
                            id: document.id || '',
                            active: document.active || false,
                            description: document.desc || '',
                            ds_number: document.ds_number || '',
                            ds_number_gp: document.ds_number_gp || '',
                            id_prod: document.id_prod || '',
                            id_supplier: document.id_supplier || '',
                            images: document.imhash || [],
                            listofPropertiesbyCar: document.prop_car || null,
                            priority: document.priority || 0,
                            ds_numbers: document.ds_numbers || [],
                            weight: document.pesoG || -1,
                            height: document.altCM || -1,
                            depth: document.profCM || -1,
                            width: document.largCM || -1,
                            sellers: growableList,
                        });
                    }
                }
            });
            
            return batchProducts;
        });

        // Wait for all batches to complete
        const batchResults = await Promise.all(batchPromises);
        
        // Combine all results
        batchResults.forEach(batchProducts => {
            allProducts.push(...batchProducts);
        });

        // Cache the results if cacheKey is provided
        if (cacheKey && allProducts.length > 0) {
            sessionStorage.setItem(cacheKey, JSON.stringify(allProducts));
        }

        return allProducts;
    };

    // Unified function to process and sort products
    const processAndSortProducts = (rawProducts) => {
        if (!rawProducts || !Array.isArray(rawProducts)) {
            console.warn('processAndSortProducts: rawProducts is not a valid array', rawProducts);
            return [];
        }

        const mappedProducts = rawProducts.map(part => {
            if (!part || !part.sellers) {
                console.warn('processAndSortProducts: Invalid part data', part);
                return null;
            }

            const filteredSellers = part.sellers.filter(seller =>
                seller && seller.name && configData.storeSellersWarehouses.includes(seller.name)
            );

            return new Product(
                part.active || false,
                part.description || '',
                part.ds_number || '',
                part.id_supplier || '',
                part.images || [],
                filteredSellers,
                { 
                    height: part.height || -1, 
                    width: part.width || -1, 
                    weight: part.weight || -1, 
                    depth: part.depth || -1 
                },
                part.listofPropertiesbyCar || null,
            );
        }).filter(product => product !== null); // Remove null products

        // Sort products - prioritize stock first, then images
        const sortedProducts = mappedProducts.sort((a, b) => {
            const aHasStock = a.getSellers().some(seller => seller && seller.stock > 0);
            const bHasStock = b.getSellers().some(seller => seller && seller.stock > 0);
            const aHasImages = a.images && Array.isArray(a.images) && a.images.length > 0;
            const bHasImages = b.images && Array.isArray(b.images) && b.images.length > 0;
            
            if (aHasStock !== bHasStock) {
                return aHasStock ? -1 : 1;
            }
            
            if (aHasImages !== bHasImages) {
                return aHasImages ? -1 : 1;
            }
            
            return 0;
        });

        return sortedProducts;
    };

    // Unified function to set products in state
    const setProductsInState = (sortedProducts) => {
        dispatch({
            type: GET_PARTS_LIST_FROM_WH,
            payload: sortedProducts,
        });

        setAllProducts(sortedProducts);
        setSortedProducts(sortedProducts);
        setDisplayedProducts(sortedProducts);
    };

    const loadProducts = async () => {
        if (category === 'vestuario') {
            setIsLoadingVestuario(true);
            try {
                // Check if we have cached products in session storage
                const cachedProducts = sessionStorage.getItem('vestuarioProducts');
                if (cachedProducts) {
                    const parsedProducts = JSON.parse(cachedProducts);
                    const sortedProducts = processAndSortProducts(parsedProducts);
                    setProductsInState(sortedProducts);
                    return;
                }

                // If no cached products, fetch from Firestore
                const allProducts = await fetchProductsFromFirestore(clothingItems, 'vestuarioProducts');
                const sortedProducts = processAndSortProducts(allProducts);
                setProductsInState(sortedProducts);
            } catch (error) {
                console.error("Error fetching products:", error);
                setIsLoadingVestuario(false);
            }
        }
        if (category === 'Acessorios-Destaque') {
            setIsLoadingVestuario(true);
            try {
                // Always fetch from Firestore (no caching)
                const allProducts = await fetchProductsFromFirestore(impulseItems);
                const sortedProducts = processAndSortProducts(allProducts);
                setProductsInState(sortedProducts);
            } catch (error) {
                console.error("Error fetching products:", error);
                setIsLoadingVestuario(false);
            }
        }
        if (category === 'dia-dos-pais') {
            setIsLoadingVestuario(true);
            try {
                // Always fetch from Firestore (no caching)
                const allProducts = await fetchProductsFromFirestore(fathersDayItems);
                const sortedProducts = processAndSortProducts(allProducts);
                setProductsInState(sortedProducts);
            } catch (error) {
                console.error("Error fetching products:", error);
                setIsLoadingVestuario(false);
            }
        }
        if (category === 'motores') {
            setIsLoadingVestuario(true);
            try {
                // Always fetch from Firestore (no caching)
                const allProducts = await fetchProductsFromFirestore(enginesItems);
                const sortedProducts = processAndSortProducts(allProducts);
                setProductsInState(sortedProducts);
            } catch (error) {
                console.error("Error fetching products:", error);
                setIsLoadingVestuario(false);
            }
        }
        // Then handle products from location.state
        else if (products && (category !== 'dia-das-maes' || category !== 'vestuario' || category !== 'dia-dos-pais')) {
            const sortedProducts = processAndSortProducts(products);
            setProductsInState(sortedProducts);
        }
        // Finally, handle productsDirect
        else if (productsDirect && productsDirect.length > 0) {
            const sortedProducts = processAndSortProducts(productsDirect);
            setProductsInState(sortedProducts);
        }
        // Rest of your existing conditions...
        else if (category === 'dia-das-maes') {
            try {
                const womansClothingIds = SliderProducts.WomansClothing;
                const allProducts = await fetchProductsFromFirestore(womansClothingIds);
                const sortedProducts = processAndSortProducts(allProducts);
                setProductsInState(sortedProducts);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        } else if (category === 'acessorios' && configData.defaultStore === 'Barigui') {
            try {
                const acessoriosIds = SliderProducts.BariguiAcessorios;
                const allProducts = await fetchProductsFromFirestore(acessoriosIds);
                const sortedProducts = processAndSortProducts(allProducts);
                setProductsInState(sortedProducts);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        } else if (!products && (configData.defaultStore === 'UmuaramaHD' || configData.defaultStore === 'UmuaramaMotos')) {
            async function getHDproducts() {
                const functions = getFunctions();
                const callableGetPartsListFromBrand = httpsCallable(functions, 'getPartsListFromBrand');
        
                // Fetch parts for both brands
                const [harleyParts, ktmParts, triumphParts] = await Promise.all([
                    callableGetPartsListFromBrand({ 'brand': "GENUINAHARLEYDAVIDSON" }),
                    callableGetPartsListFromBrand({ 'brand': "GENUINAKTM" }),
                    callableGetPartsListFromBrand({ 'brand': "GENUINATRIUMPH" })
                ]).then(([harleyResult, ktmResult, triumphResult]) => {
                    return [harleyResult.data, ktmResult.data, triumphResult.data];
                }).catch((error) => {
                    console.error(error);
                    return [[], []]; // Return empty arrays on error
                });
        
                const listofArticles = [...harleyParts, ...ktmParts, ...triumphParts].map(document => {
                    if (document != null) {
                        const listOfSellers = document["sellersList"];
                        const growableList = [];
                        const storeprice = configData.defaultStore === "GoParts" ? "price_ecommerce_gp" : "price_ecommerce_seller";
        
                        listOfSellers.forEach((element) => {
                            if (configData.storeSellersWarehouses.includes(element)) {
                                growableList.push({
                                    id: document["id"].toString(),
                                    active: document[element]["active"],
                                    name: document[element]["name"],
                                    price: document[element]["price"],
                                    stock: document[element]["stock"],
                                    price_ecommerce: document[element].hasOwnProperty(storeprice)
                                        ? document[element][storeprice]
                                        : document[element]["price"],
                                    distance: 1
                                });
                            }
                        });
        
                        return {
                            id: document['id'],
                            active: document['active'],
                            description: document['desc'],
                            ds_number: document['ds_number'],
                            ds_number_gp: document['ds_number_gp'],
                            id_prod: document['id_prod'],
                            id_supplier: document['id_supplier'],
                            images: document['imhash'],
                            listofPropertiesbyCar: document.hasOwnProperty('prop_car') ? document['prop_car'] : null,
                            priority: document['priority'],
                            ds_numbers: document['ds_numbers'],
                            weight: document.hasOwnProperty('pesoG') ? document['pesoG'] : -1,
                            height: document.hasOwnProperty('altCM') ? document['altCM'] : -1,
                            depth: document.hasOwnProperty('profCM') ? document['profCM'] : -1,
                            width: document.hasOwnProperty('largCM') ? document['largCM'] : -1,
                            sellers: growableList,
                        };
                    }
                    return null; // Return null for invalid documents
                }).filter(Boolean); // Filter out null values
        
                const mappedProducts = listofArticles.map(part => {
                    const filteredSellers = part.sellers.filter(seller =>
                        configData.storeSellersWarehouses.includes(seller.name)
                    );
        
                    return new Product(
                        part.active,
                        part.description,
                        part.ds_number,
                        part.id_supplier,
                        part.images,
                        filteredSellers,
                        { height: part.height, width: part.width, weight: part.weight, depth: part.depth },
                        part.listofPropertiesbyCar,
                    );
                });
        
                const callableGetHDCategoriesItems = httpsCallable(functions, 'getUMotosCategories');
                // const callableGetHDCategoriesItems = httpsCallable(functions, 'getHDCategoriesItems');
                const filteredProducts = await callableGetHDCategoriesItems({ 'category': category}).then((result) => {
                    let filtered;
                    if (category === "KTM") {
                        filtered = mappedProducts.filter(item => item.supplier === "GENUINAKTM" && !result['data'].includes(item.ds_number));
                    } else if (category === "Triumph") {
                        filtered = mappedProducts.filter(item => item.supplier === "GENUINATRIUMPH" && !result['data'].includes(item.ds_number));
                    } else if (category !== "Peças") {
                        filtered = mappedProducts.filter(item => result['data'].includes(item.ds_number));
                    } else {
                        filtered = mappedProducts.filter(item => !result['data'].includes(item.ds_number));
                    }
        
                    // Sort products - prioritize stock first, then images
                    filtered.sort((a, b) => {
                        const aHasStock = a.getSellers().some(seller => seller.stock > 0);
                        const bHasStock = b.getSellers().some(seller => seller.stock > 0);
                        const aHasImages = a.images.length > 0;
                        const bHasImages = b.images.length > 0;
                        
                        // Different stock status
                        if (aHasStock !== bHasStock) {
                            return aHasStock ? -1 : 1;
                        }
                        
                        // Same stock status, sort by images
                        if (aHasImages !== bHasImages) {
                            return aHasImages ? -1 : 1;
                        }
                        
                        return 0; // maintain relative order if both have same status
                    });
        
                    return filtered;
                });
        
                dispatch({
                    type: GET_PARTS_LIST_FROM_WH,
                    payload: filteredProducts,
                });
        
                setAllProducts(filteredProducts);
                setSortedProducts(filteredProducts);
                setDisplayedProducts(filteredProducts);
            }
        
            getHDproducts();
        } else if (!products && (configData.defaultStore === 'NissulYamaha' || configData.defaultStore === 'BelcarYamaha')) {
            async function getYamahaProducts() {
                const functions = getFunctions();
                const callableGetPartsListFromBrand = httpsCallable(functions, 'getPartsListFromBrand');
        
                // Fetch only Yamaha parts
                const yamahaResult = await callableGetPartsListFromBrand({ 'brand': "GENUINAYAMAHA" })
                    .then((result) => {
                        return result.data;
                    })
                    .catch((error) => {
                        console.error(error);
                        return []; // Return empty array on error
                    });
        
                const listofArticles = yamahaResult.map(document => {
                    if (document != null) {
                        const listOfSellers = document["sellersList"];
                        const growableList = [];
                        const storeprice = configData.defaultStore === "GoParts" ? "price_ecommerce_gp" : "price_ecommerce_seller";
        
                        listOfSellers.forEach((element) => {
                            if (configData.storeSellersWarehouses.includes(element)) {
                                growableList.push({
                                    id: document["id"].toString(),
                                    active: document[element]["active"],
                                    name: document[element]["name"],
                                    price: document[element]["price"],
                                    stock: document[element]["stock"],
                                    price_ecommerce: document[element].hasOwnProperty(storeprice)
                                        ? document[element][storeprice]
                                        : document[element]["price"],
                                    distance: 1
                                });
                            }
                        });
        
                        return {
                            id: document['id'],
                            active: document['active'],
                            description: document['desc'],
                            ds_number: document['ds_number'],
                            ds_number_gp: document['ds_number_gp'],
                            id_prod: document['id_prod'],
                            id_supplier: document['id_supplier'],
                            images: document['imhash'],
                            listofPropertiesbyCar: document.hasOwnProperty('prop_car') ? document['prop_car'] : null,
                            priority: document['priority'],
                            ds_numbers: document['ds_numbers'],
                            weight: document.hasOwnProperty('pesoG') ? document['pesoG'] : -1,
                            height: document.hasOwnProperty('altCM') ? document['altCM'] : -1,
                            depth: document.hasOwnProperty('profCM') ? document['profCM'] : -1,
                            width: document.hasOwnProperty('largCM') ? document['largCM'] : -1,
                            sellers: growableList,
                        };
                    }
                    return null; // Return null for invalid documents
                }).filter(Boolean); // Filter out null values
        
                const mappedProducts = listofArticles.map(part => {
                    const filteredSellers = part.sellers.filter(seller =>
                        configData.storeSellersWarehouses.includes(seller.name)
                    );
        
                    return new Product(
                        part.active,
                        part.description,
                        part.ds_number,
                        part.id_supplier,
                        part.images,
                        filteredSellers,
                        { height: part.height, width: part.width, weight: part.weight, depth: part.depth },
                        part.listofPropertiesbyCar,
                    );
                });
        
                // Sort products - prioritize stock first, then images
                const sortedProducts = mappedProducts.sort((a, b) => {
                    const aHasStock = a.getSellers().some(seller => seller.stock > 0);
                    const bHasStock = b.getSellers().some(seller => seller.stock > 0);
                    const aHasImages = a.images.length > 0;
                    const bHasImages = b.images.length > 0;
                    
                    // Different stock status
                    if (aHasStock !== bHasStock) {
                        return aHasStock ? -1 : 1;
                    }
                    
                    // Same stock status, sort by images
                    if (aHasImages !== bHasImages) {
                        return aHasImages ? -1 : 1;
                    }
                    
                    return 0; // maintain relative order if both have same status
                });
        
                dispatch({
                    type: GET_PARTS_LIST_FROM_WH,
                    payload: sortedProducts,
                });
        
                setAllProducts(sortedProducts);
                setSortedProducts(sortedProducts);
                setDisplayedProducts(sortedProducts);
            }
        
            getYamahaProducts();
        }
    };

    const applySortAndFilter = (sortOption, sizeFilter, textFilter = '') => {
        let sorted = [...allProducts];
    
        // Helper function to get the price of a product
        const getPrice = (product, priceType) => {
            const sellers = product.getSellers();
            if (sellers.length > 0) {
                return sellers[0][priceType] || 0; // Return 0 if price is missing
            }
            return 0; // If no sellers, return 0
        };
    
        // Helper function to calculate the absolute discount
        const getDiscount = (product) => {
            const originalPrice = getPrice(product, "price"); // Use "price" for original price
            const ecommercePrice = getPrice(product, "price_ecommerce");
            // Return 0 discount if either price is 0 or missing
            return (originalPrice <= 0 || ecommercePrice <= 0) ? 0 : Math.abs(originalPrice - ecommercePrice);
        };
    
        if (sortOption === 'lowestPrice') {
            sorted.sort((a, b) => {
                const priceA = getPrice(a, "price_ecommerce");
                const priceB = getPrice(b, "price_ecommerce");
    
                // Move products without sellers to the end
                if (priceA === 0 && priceB === 0) return 0; // Both products have no sellers
                if (priceA === 0) return 1; // a has no sellers, put it after b
                if (priceB === 0) return -1; // b has no sellers, put it after a
    
                return priceA - priceB; // Sort by lowest price
            });
        } else if (sortOption === 'highestPrice') {
            sorted.sort((a, b) => {
                const priceA = getPrice(a, "price_ecommerce");
                const priceB = getPrice(b, "price_ecommerce");
                return priceB - priceA;
            });
        } else if (sortOption === 'alphabetical') {
            sorted.sort((a, b) => {
                const descA = a.getDescription ? a.getDescription() : a.description || '';
                const descB = b.getDescription ? b.getDescription() : b.description || '';
                return descA.localeCompare(descB);
            });
        } else if (sortOption === 'highestDiscount') {
            sorted.sort((a, b) => getDiscount(b) - getDiscount(a)); // Sort by absolute discount, highest to lowest
        }
    
        let filtered = sorted;
        
        // Apply text filter if provided
        if (textFilter && textFilter.trim() !== '') {
            const searchTerm = textFilter.toLowerCase().trim();
            filtered = sorted.filter(product => {
                const description = product.getDescription ? product.getDescription() : product.description || '';
                const dsNumber = product.getCode ? product.getCode() : product.ds_number || '';
                
                return description.toLowerCase().includes(searchTerm) || 
                       dsNumber.toLowerCase().includes(searchTerm);
            });
        }
        
        // Apply size filter if provided
        if (sizeFilter && sizeFilter !== 'default') {
            const equivalents = sizeEquivalents[sizeFilter] || [sizeFilter];
            const regex = new RegExp(`\\b(${equivalents.join('|')})\\b`, 'i');
            filtered = filtered.filter(product => {
                const desc = product.getDescription ? product.getDescription() : product.description || '';
                return regex.test(desc);
            });
        }
    
        setSortedProducts(sorted);
        setDisplayedProducts(filtered);
    };

    useEffect(() => {
        applySortAndFilter(sortOption, selectedSize, searchText);
        // eslint-disable-next-line
    }, [allProducts]);

       // Initial load of products
    useEffect(() => {
        setIsLoading(true);
        loadProducts();
    }, [products, dispatch]);

    // New useEffect to listen for category changes
    useEffect(() => {
        setIsLoading(true);
        // Call the loadProducts function whenever the category changes
        loadProducts();
    }, [category]); // Add category as a dependency

    useEffect(() => {
        filterProductsByPrice();
    }, [priceRangeStart, priceRangeEnd]);

    useEffect(() => {
        applySortAndFilter(sortOption, selectedSize, searchText);
    }, [searchText]);

    const sortProducts = (option) => {
        let sorted = [...allProducts];
    
        // Helper function to get the price of a product
        const getPrice = (product, priceType) => {
            const sellers = product.getSellers();
            if (sellers.length > 0) {
                return sellers[0][priceType] || 0; // Return 0 if price is missing
            }
            return 0; // If no sellers, return 0
        };
    
        // Helper function to calculate the absolute discount
        const getDiscount = (product) => {
            const originalPrice = getPrice(product, "price"); // Use "price" for original price
            const ecommercePrice = getPrice(product, "price_ecommerce");
            // Return 0 discount if either price is 0 or missing
            return (originalPrice <= 0 || ecommercePrice <= 0) ? 0 : Math.abs(originalPrice - ecommercePrice);
        };
    
        if (option === 'lowestPrice') {
            sorted.sort((a, b) => {
                const priceA = getPrice(a, "price_ecommerce");
                const priceB = getPrice(b, "price_ecommerce");
    
                // Move products without sellers to the end
                if (priceA === 0 && priceB === 0) return 0; // Both products have no sellers
                if (priceA === 0) return 1; // a has no sellers, put it after b
                if (priceB === 0) return -1; // b has no sellers, put it after a
    
                return priceA - priceB; // Sort by lowest price
            });
        } else if (option === 'highestPrice') {
            sorted.sort((a, b) => {
                const priceA = getPrice(a, "price_ecommerce");
                const priceB = getPrice(b, "price_ecommerce");
                return priceB - priceA;
            });
        } else if (option === 'alphabetical') {
            sorted.sort((a, b) => a.getDescription().localeCompare(b.getDescription()));
        } else if (option === 'highestDiscount') {
            sorted.sort((a, b) => getDiscount(b) - getDiscount(a)); // Sort by absolute discount, highest to lowest
        }
    
        setSortedProducts(sorted);
        setDisplayedProducts(sorted); // Update the displayed products whenever sorting changes
    };

    const filterProductsByPrice = () => {
        const startPrice = parseCurrency(priceRangeStart) || 0;
        const endPrice = parseCurrency(priceRangeEnd) || Infinity;

        const filteredProducts = sortedProducts.filter(product => {
            const price = product.getSellers().length > 0 ? product.getSellers()[0].price_ecommerce : 0;
            return price >= startPrice && price <= endPrice;
        });

        // Apply search filter after price filtering
        let finalFiltered = filteredProducts;
        if (searchText && searchText.trim() !== '') {
            const searchTerm = searchText.toLowerCase().trim();
            finalFiltered = filteredProducts.filter(product => {
                const description = product.getDescription ? product.getDescription() : product.description || '';
                const dsNumber = product.getCode ? product.getCode() : product.ds_number || '';
                
                return description.toLowerCase().includes(searchTerm) || 
                       dsNumber.toLowerCase().includes(searchTerm);
            });
        }

        setDisplayedProducts(finalFiltered);
    };

    const handleSortChange = (event) => {
        const newSortOption = event.target.value;
        setSortOption(newSortOption);
        applySortAndFilter(newSortOption, selectedSize, searchText);
    };

    const sizeEquivalents = {
        'PP': ['PP', 'XS'],
        'XS': ['PP', 'XS'],
        'P': ['P', 'S'],
        'S': ['P', 'S'],
        'M': ['M'],
        'G': ['G', 'L'],
        'L': ['G', 'L'],
        'GG': ['GG', 'XL'],
        'XL': ['GG', 'XL'],
    };

    const handleFilterChange = (event) => {
        const newSize = event.target.value;
        setSelectedSize(newSize);
        applySortAndFilter(sortOption, newSize, searchText);
    };

    const handleSearchChange = (event) => {
        const newSearchText = event.target.value;
        setSearchText(newSearchText);
        applySortAndFilter(sortOption, selectedSize, newSearchText);
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    const openVehicleSelect = () => {
        dispatch(setIsSelectingVehicle(!isSelectingVehicle));
    };

    const handlePriceRangeChangeStart = (event) => {
        const value = event.target.value.replace(/\D/g, ''); // Only allow numbers
        const numericValue = parseInt(value, 10); // Convert to integer
        const formattedValue = numericValue > 0 ? formatCurrency(numericValue / 100) : '';
        setPriceRangeStart(formattedValue);
    };
    
    const handlePriceRangeChangeEnd = (event) => {
        const value = event.target.value.replace(/\D/g, ''); // Only allow numbers
        const numericValue = parseInt(value, 10); // Convert to integer
        const formattedValue = numericValue > 0 ? formatCurrency(numericValue / 100) : '';
        setPriceRangeEnd(formattedValue);
    };

    const handleSizeSelect = (size) => {
        setFilteredSizes(prevSizes =>
            prevSizes.includes(size) ? prevSizes.filter(s => s !== size) : [...prevSizes, size]
        );
    };

    const handleClearFilters = () => {
        setFilteredSizes([]);
        setExpandedFilters(false);
        setPriceRangeStart('');
        setPriceRangeEnd('');
        setSearchText(''); // Clear search text
        applySortAndFilter(sortOption, selectedSize, ''); // Reapply filters without search text
    };

    useEffect(() => {
        if (displayedProducts.length > 0) {
            setIsLoading(false);
            setIsLoadingDirect(false);
            setIsLoadingVestuario(false);
        }
    }, [displayedProducts]);

    // useEffect(() => {
    //     if ((!configData.noVehicle) && !selectedVersion) {
    //         openVehicleSelect();
    //     }
    // }, [selectedVersion]);

    const keepVehicleSelection = () => {
        if ((configData.noVehicle)) {
            dispatch(setIsSelectingVehicle(false));
            dispatch(setSelectedBrand('uhd'));
            dispatch(setSelectedYear('2020'));
            dispatch(setSelectedModel('softail'));
            dispatch(setSelectedVersion('abc'));
        }
    }

    useEffect(() => {
        keepVehicleSelection();
    }, [configData.noVehicle]);

    // Add helmetData using the unified utility
    const helmetData = buildHelmetData(configData, websitesIndexData, {
        pageName: category,
        allowIndex: true, // Product category pages should be indexed for SEO
        additionalKeywords: `${category?.toLowerCase()}, peças originais, ${selectedBrand || ''} ${selectedModel || ''}, ${selectedYear || ''}, autopeças, peças genuínas, ${displayedProducts.slice(0, 5).map(p => p.getDescription().split(' ')[0]).join(', ')}`
    });

    const removeOutOfStockProducts = () => {
        const productsWithStock = displayedProducts.filter(product => {
            return product.getSellers().some(seller => seller.stock > 0);
        });
        setDisplayedProducts(productsWithStock);
    };

    useEffect(() => {
        if (displayedProducts.length > 0) {
            removeOutOfStockProducts();
        }
    }, [displayedProducts]);

    useEffect(() => {
        if (selectedCar && selectedCar.InternalID && allOEs?.parts && allOEs.parts.length > 0) {
            const categoryIds = getCategoriesIds(category);
            if (categoryIds && categoryIds.length > 0) {
                loadParts(selectedCar, categoryIds, true, "all", allOEs);
            }
        }
    }, [selectedCar, allOEs, category]);

    useEffect(() => {
        if (productsDirect && productsDirect.length > 0) {
            loadProducts();
        }
    }, [productsDirect]);

    return (
        <div className='main fadeIn'>
            {helmetData && (
                configData.defaultStore === 'Recreio' ? (
                    <Helmet>
                        <title>Produtos Originais Volkswagen | Recreio VW</title>
                        <meta name="description" content="Confira todos os produtos disponíveis na Recreio VW. Peças e acessórios genuínos Volkswagen com envio rápido e segurança na compra." />
                        
                        <meta name="robots" content={helmetData.robots} />
                        <meta name="googlebot" content={helmetData.robots} />
                        
                        <meta property="og:type" content={helmetData.social.type} />
                        <meta property="og:url" content={helmetData.social.url} />
                        <meta property="og:title" content="Produtos Originais Volkswagen | Recreio VW" />
                        <meta property="og:description" content="Confira todos os produtos disponíveis na Recreio VW. Peças e acessórios genuínos Volkswagen com envio rápido e segurança na compra." />
                        <meta property="og:image" content={helmetData.social.image} />
                        
                        <meta property="twitter:card" content="summary_large_image" />
                        <meta property="twitter:url" content={helmetData.social.url} />
                        <meta property="twitter:title" content="Produtos Originais Volkswagen | Recreio VW" />
                        <meta property="twitter:description" content="Confira todos os produtos disponíveis na Recreio VW. Peças e acessórios genuínos Volkswagen com envio rápido e segurança na compra." />
                        <meta property="twitter:image" content={helmetData.social.image} />
                        
                        <meta name="keywords" content="produtos volkswagen originais, peças vw com garantia, catálogo de peças recreio vw" />
                        <link rel="canonical" href={helmetData.canonical} />
                    </Helmet>
                ) : (
                    <Helmet>
                        <title>{helmetData.title}</title>
                        <meta name="description" content={helmetData.description} />
                        
                        <meta name="robots" content={helmetData.robots} />
                        <meta name="googlebot" content={helmetData.robots} />
                        
                        <meta property="og:type" content={helmetData.social.type} />
                        <meta property="og:url" content={helmetData.social.url} />
                        <meta property="og:title" content={helmetData.social.title} />
                        <meta property="og:description" content={helmetData.social.description} />
                        <meta property="og:image" content={helmetData.social.image} />
                        
                        <meta property="twitter:card" content="summary_large_image" />
                        <meta property="twitter:url" content={helmetData.social.url} />
                        <meta property="twitter:title" content={helmetData.social.title} />
                        <meta property="twitter:description" content={helmetData.social.description} />
                        <meta property="twitter:image" content={helmetData.social.image} />
                        
                        <meta name="keywords" content={helmetData.keywords} />
                        <link rel="canonical" href={helmetData.canonical} />
                    </Helmet>
                )
            )}
            {(configData.defaultStore === 'UmuaramaHD' || configData.defaultStore === 'UmuaramaMotos') &&
                <div className='productsPageBg' style={{ backgroundImage: `url(${productPageBg})` }}>
                    <div className='umuaramaHDnav'>
                        <Home style={{ color: 'var(--secondColor)', fontSize: '18px' }} />
                        <Link to='/'>Página Inicial</Link>
                        <span>›</span>
                        <Link to={`/categorias/${brandName}`}>{capitalizeWords(brandName)}</Link>
                        <span>›</span>
                        <span>{categoryName}</span>
                    </div>
                    <div className='productBannerColumn'>
                        <img src={brandLogos[category]} className='brandLogoProductBanner' alt={categoryName}/>
                        <h2>{categoryName}</h2>
                    </div>
                </div>
            }
            <div className={`pageContent ${(configData.defaultStore === 'UmuaramaHD' || configData.defaultStore === 'UmuaramaMotos') ? 'UhdTopMargin' : ''}`}>
                <div className='pageHeader'>
                    {(configData.defaultStore !== 'NissulYamaha' && configData.defaultStore !== 'BelcarYamaha' && configData.defaultStore !== 'UmuaramaMotos') &&
                        <div className='row' style={{ alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}>
                            <a className='grayedText' onClick={handleBackClick}><ArrowBackSharp style={{ fontSize: '18px', marginRight: '4px' }} /></a>
                            {(image || getCategoryImage()) && <img src={image || getCategoryImage()} alt={`Autopeças em ${categoryName}`} style={{ width: '48px' }} />}
                            <h1 style={{ whiteSpace: 'wrap' }}>{categoryName}</h1>
                        </div>
                    }
                    {(vehicleState.selectedVersion || (configData.noVehicle || category === 'dia-das-maes' || category === 'vestuario' || category === 'Acessorios-Destaque' || category === 'dia-dos-pais' || category === 'motores')) &&
                        <div className='column' style={{width: '100%', gap: '10px'}}>
                            <div className='row' style={{width: '100%', alignItems: 'center', justifyContent: 'space-between'}}>
                                <div className='row' style={{ alignItems: 'center', gap: '6px' }}>
                                    <Search style={{ color: 'var(--secondColor)', fontSize: '18px' }} />
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <input
                                            type="text"
                                            placeholder="Filtrar produtos..."
                                            value={searchText}
                                            onChange={handleSearchChange}
                                            style={{ 
                                                padding: '6px 12px', 
                                                paddingRight: searchText ? '30px' : '12px',
                                                border: '1px solid var(--borderColor)', 
                                                borderRadius: '4px',
                                                minWidth: '140px',
                                                fontSize: '14px'
                                            }}
                                        />
                                        {searchText && (
                                            <Close 
                                                style={{ 
                                                    position: 'absolute', 
                                                    right: '8px', 
                                                    fontSize: '16px', 
                                                    color: 'var(--secondColor)',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    setSearchText('');
                                                    applySortAndFilter(sortOption, selectedSize, '');
                                                }}
                                            />
                                        )}
                                    </div>
                                    <Sort />
                                    {!isMobile &&
                                        <span style={{ whiteSpace: 'nowrap' }}>Ordenar: </span>
                                    }
                                    <select style={{ maxWidth: '200px' }} onChange={handleSortChange}>
                                        <option value='default'>Relevância</option>
                                        <option value='lowestPrice'>Menor preço</option>
                                        <option value='highestPrice'>Maior preço</option>
                                        <option value='highestDiscount'>Maior desconto</option>
                                        <option value='alphabetical'>Ordem Alfabética</option>
                                    </select>
                                    {(category === 'vestuario' || category === 'dia-das-maes' || category.includes('Boutique') || category === 'dia-dos-pais') &&
                                        <>
                                            <span style={{ whiteSpace: 'nowrap' }}>Tamanho: </span>
                                            <select style={{ maxWidth: '200px' }} onChange={handleFilterChange}>
                                                <option value='default'>Todos</option>
                                                <option value='PP'>PP</option>
                                                <option value='P'>P</option>
                                                <option value='M'>M</option>
                                                <option value='G'>G</option>
                                                <option value='GG'>GG</option>
                                            </select>
                                        </>
                                    }
                                </div>

                                {/* {expandedFilters
                                    ?
                                        <Button
                                            className='buttonColorSecond smallButton'
                                            iconStart={<KeyboardArrowUp/>}
                                            onClick={() => setExpandedFilters(false)}
                                        />
                                    :
                                        <div style={{position: 'relative'}}>
                                            <Button
                                                className='buttonColorSecond smallButton'
                                                iconStart={<FilterList/>}
                                                onClick={() => setExpandedFilters(true)}
                                            />
                                            {(filteredSizes.length > 0 || priceRangeStart !== '' || priceRangeEnd !== '') &&
                                                <div className='filterIndicator'/>
                                            }
                                        </div>
                                } */}

                            </div>
                            
                            {/* {expandedFilters &&
                                <div className='column fadeIn' style={{gap: '6px', margin: '6px 0 10px 0'}}>
                                    <div className='row' style={{ alignItems: 'center', gap: '6px' }}>
                                        <span style={{ whiteSpace: 'nowrap' }}>Faixa de preço: </span>
                                        <span className='grayedText'>de</span>
                                        <input
                                            style={{ maxWidth: '90px' }}
                                            value={priceRangeStart}
                                            onChange={handlePriceRangeChangeStart}
                                            placeholder="R$ 0,00"
                                        />
                                        <span className='grayedText'>até</span>
                                        <input
                                            style={{ maxWidth: '90px' }}
                                            value={priceRangeEnd}
                                            onChange={handlePriceRangeChangeEnd}
                                            placeholder="R$ 0,00"
                                        />
                                    </div>

                                    {hasClothing &&
                                        <div className='row' style={{ alignItems: 'center', gap: '6px' }}>
                                            <span style={{ whiteSpace: 'nowrap' }}>Tamanhos: </span>
                                            <div className='row' style={{gap: '4px'}}>
                                                {Object.entries(sizeFilterOptions).map(([key, value]) => (
                                                    <div
                                                        key={key}
                                                        className={`defaultBorderedItem sizePicker ${filteredSizes.includes(value) ? 'selectedSizePicker' : ''}`}
                                                        onClick={() => handleSizeSelect(value)}
                                                    >
                                                        <span>{value}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    }
                                    {(filteredSizes.length > 0 || priceRangeStart !== '' || priceRangeEnd !== '') &&
                                        <div className='row' style={{alignItems: 'center', gap: '4px', justifyContent: 'end'}}>
                                            <Close style={{fontSize: '16px', color: 'var(--secondColor)'}}/>
                                            <a className='fadeIn' onClick={handleClearFilters}>remover filtros</a>
                                        </div>
                                    }
                                </div>
                            } */}
                            
                        </div>
                    }
                    </div>
                    {vehicleState.selectedVersion || configData.defaultStore === 'UmuaramaHD' || category === 'dia-das-maes' || category === 'vestuario' || category === 'Acessorios-Destaque' || category === 'dia-dos-pais' || category === 'motores'
                        ? 
                            (
                                <>
                                    {category !== '...'
                                        ?
                                            <>
                                                {isLoading || isLoadingDirect || isLoadingVestuario
                                                    ?
                                                        <div className='column center' style={{minHeight: '200px', maxHeight: '80vh'}}>
                                                            <CircularProgress
                                                                sx={{ color: 'var(--secondColor)' }}
                                                            />
                                                        </div>
                                                    :
                                                        <div className='centerGrid' style={{ marginTop: '10px' }}>
                                                            {displayedProducts.length > 0
                                                                ?
                                                                    <div className='tileGrid fadeIn'>
                                                                        {displayedProducts.map(product => (
                                                                            <ProductTile
                                                                                key={product.getCode()}
                                                                                product={product}
                                                                                vehicle={vehicleState}
                                                                                defaultImage={image}
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                :
                                                                    <span className='grayedText fadeInLong' style={{margin: '10px'}}>
                                                                        {selectedVersion
                                                                        ?
                                                                            'Nenhum produto encontrado para ' + selectedBrand.charAt(0).toUpperCase() + selectedBrand.slice(1) + ' ' + selectedModel + ' ' + selectedYear + ' ' + selectedVersion
                                                                        :
                                                                            'Nenhum produto encontrado'
                                                                        }
                                                                    </span>
                                                            }
                                                        </div>
                                                }
                                            </>
                                        :
                                            <div className='center' style={{marginTop: '40px'}}>
                                                <h1>Peças Triumph em breve.</h1>
                                            </div>
                                    }
                                </>
                            )
                        :
                            (
                                <div className='pageContent center column' style={{ gap: '10px' }}>
                                    <h2 style={{ textAlign: 'center' }}>
                                        Selecione um veículo para ver peças compatíveis em <span style={{ fontWeight: '700' }}>{categoryName}</span>.
                                    </h2>
                                    <Button
                                        className='giantButton'
                                        iconStart={<span><AddCar style={{color: 'white', position: 'relative', zIndex: 1}}/></span>}
                                        label='Selecionar'
                                        onClick={openVehicleSelect}
                                    />
                                </div>
                                // <div className='column center' style={{gap: '10px'}}>
                                //     <h2 style={{ textAlign: 'center' }}>
                                //         Selecione um veículo para ver peças compatíveis em <span style={{ fontWeight: '700' }}>{category}</span>.
                                //     </h2>
                                //     <div className='defaultRowBrands'>
                                //         {configData.brands.map((item) => {
                                //             const brandName = item.charAt(0).toUpperCase() + item.slice(1);
                                //             const imageSrc = BrandsList[brandName];
                                //             return imageSrc ? (
                                //             <div
                                //                 className='headerFilterOption'
                                //                 key={item}
                                //                 onClick={() => vehicleSelectWithBrand(item)}
                                //             >
                                //                 <img className='headerFilterBrandLogo' src={imageSrc} alt={item} />
                                //             </div>
                                //             ) : (
                                //             <div className='headerFilterOption' style={{ color: 'white' }} key={item}>
                                //                 {item}
                                //             </div>
                                //             );
                                //         })}
                                //     </div>
                                //     <div className='column center' style={{gap: '6px'}}>
                                //         <span>ou</span>
                                //         <Button
                                //             onClick={openVehicleSelectOnly}
                                //             className="buttonColorThird smallButton"
                                //             label="Encontre pela placa"
                                //             iconStart={<Search/>}
                                //         />
                                //     </div>
                                // </div>
                            )
                    }
                </div>
            </div>
        );
    }
    
    export default Products;
    